export default __webpack_public_path__ + "static/media/lyte-chocolate-bar@3x.2f41a820.png";